/**
 * Instalação do app IAT vinda da Loja de Aplicativos da Nuvemshop.
 *
 * O lojista pode clicar em "Instalar" sem ter conta na IAT. Nesse caso a
 * Nuvemshop nos devolve um `code` que vale só 5 minutos — tempo que não cabe um
 * cadastro. Em vez de tentar guardar o código, guardamos a INTENÇÃO de instalar
 * e, assim que o usuário entra ou se cadastra, refazemos a autorização do zero
 * (ele continua logado na Nuvemshop, então volta com um código novo).
 */
import { getBackendUrl } from './api';

const CHAVE = 'nuvemshop_instalacao_pendente';
// Curto de propósito: é o tempo de um cadastro, não um estado permanente.
const TTL_MS = 30 * 60 * 1000;

export const marcarInstalacaoPendente = () => {
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ ts: Date.now() }));
  } catch (_) { /* modo privado: seguimos sem o atalho */ }
};

export const temInstalacaoPendente = () => {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (!bruto) return false;
    const { ts } = JSON.parse(bruto) || {};
    if (!ts || Date.now() - ts > TTL_MS) {
      localStorage.removeItem(CHAVE);
      return false;
    }
    return true;
  } catch (_) {
    return false;
  }
};

export const limparInstalacaoPendente = () => {
  try {
    localStorage.removeItem(CHAVE);
  } catch (_) { /* ignore */ }
};

/**
 * Empresa em que a loja será conectada. Logo depois do cadastro o
 * `selectedCompany` ainda pode não existir no localStorage, e o backend recusa
 * a conexão sem companyId — por isso o fallback pela API.
 */
export const resolverCompanyId = async (user) => {
  try {
    const bruto = localStorage.getItem('selectedCompany');
    const salvo = bruto ? (JSON.parse(bruto) || {}).companyId : '';
    if (salvo) return salvo;
  } catch (_) { /* segue para o fallback */ }

  if (!user) return '';
  try {
    const token = await user.getIdToken();
    const resp = await fetch(`${getBackendUrl()}/api/user-companies`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    if (!resp.ok) return '';
    const data = await resp.json();
    return (data.companies || [])[0]?.companyId || '';
  } catch (_) {
    return '';
  }
};
